import _momentum from "./momentum";
var exports = {};
var momentum = _momentum;

function use(moment) {
  this.moment = momentum.moment = moment;
}

exports = use;
export default exports;